<template>
    <div class="modal-backdrop">
        <!--<div class="" id="deleteAlert" >-->
            <!--<div class="modal-dialog" role="document">-->
                <!--<div class="modal-content">-->
                    <!--<div class="modal-header">-->
                        <!--<h5 class="modal-title" id="deleteAlertTitle">Warning</h5>-->
                    <!--</div>-->
                    <!--<div class="modal-body">-->

                    <!--</div>-->
                    <!--<div class="modal-footer">-->
                        <!--<button type="button" class="btn btn-secondary" @click="closeForm">Close</button>-->
                        <!--<button type="button" class="btn btn-primary" @click="saveCurrentNode">Save changes</button>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <div class="h-100" id="nodeModal">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="nodeModalLabel">Edit</h5>
                        <button type="button" class="close" @click="closeForm"
                                aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label for="nodeTitle">Title</label>
                                <input type="text" class="form-control" id="nodeTitle" v-model="form.title">
                            </div>
                            <div class="form-group">
                                <label for="nodeOrder">Order</label>
                                <input type="text" class="form-control" id="nodeOrder" v-model="form.order">
                            </div>
                            <div class="form-group">
                                <label for="nodeType">Type</label>
                                <select class="form-control" id="nodeType" v-model="form.type">
                                    <option value="article">article</option>
                                    <option value="node">node</option>
                                </select>
                            </div>
                            <div class="form-group" v-if="form.type === 'article'">
                                <label for="article">Article</label>
                                <multiselect v-model="articleObj"
                                             id="article"
                                             track-by="article_id"
                                             :options="articleSuggestions()"
                                             @select="onArticleSelected"
                                             :internalSearch="true"
                                             :clearOnSelect="true"
                                             label="article"
                                             :show-labels="false"

                                >
                                    <template slot="singleLabel" slot-scope="props">
                                        <span>
                                             <span>{{ props.option.article_title}}</span>
                                        </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div>
                                            <span>{{ props.option.article_title + ' (' + props.option.domain + ' -> ' + props.option.subdomain + ')'}}</span>
                                        </div>
                                    </template>
                                </multiselect>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" v-if="formType !== 'new'" class="btn btn-danger" @click="deleteNode">Delete</button>
                        <!--<button type="button" class="btn btn-secondary" @click="closeForm">Close</button>-->
                        <button type="button" :class="getButtonClass()" @click="saveCurrentNode">Save changes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect';
    import 'vue-multiselect/dist/vue-multiselect.min.css';

    export default {

        components: {
            Multiselect,
        },

        props: {
            'node': {
                type: Object,
                default: null
            },
            'formType': {
                type: String,
            },
            'domains': {
                type: Array,
            },
            'product': {
                type: String,
                default: null
            }
        },

        data() {
            return {
                form: this.getDefaultForm(),
                articleObj: this.getSelectedArticle(),
            }
        },

        methods: {
            saveCurrentNode: function() {
                console.log(this.form.article);
                this.$emit('saveCurrentNode', this.form);
            },

            closeForm: function(){
                this.form = this.getDefaultForm();
                this.$emit('toggleForm', false);
            },

            getSelectedArticle: function(){
                let data = {
                    'article_id': null,
                    'domain': null,
                    'subdomain': null,
                    'article': null
                };
                if (this.formType === 'edit') {
                    if (this.node.type !== 'article') {
                        return data;
                    }
                    data['article_id'] = this.node.article;
                    if (!this.node.article_details) {
                        return data;
                    }
                    let obj =_.find(this.node.article_details.article_translation_set, {'language': locale});
                    if (obj && typeof obj !== 'undefined') {
                        console.log('here');
                        return {
                            'article_id': this.node.article,
                            'domain': null,
                            'subdomain': null,
                            'article_title':  obj.title,
                            'article_details': this.node.article_details
                        }
                    }
                }
                return {
                    'article_id': null,
                    'domain': null,
                    'subdomain': null,
                    'article_details': null
                }
            },

            getDefaultForm: function() {
                if (this.formType === 'edit') {
                    console.log(this.node.article);
                    return {
                        title: this.node.decision_node_translation_set[0].title,
                        order: this.node.order,
                        type: this.node.type,
                        article: this.node.article,
                        article_details: this.node.article_details,
                        isNewNode: false,
                        deleted: false,
                    }
                }
                return {
                    title: "",
                    order: this.node.children.length + 1,
                    type: 'article',
                    article: null,
                    article_details: null,
                    isNewNode: true,
                    deleted: false,
                }
            },

            deleteNode: function() {
                let message = "Weet je zeker dat je" + this.form.title + "en zijn kinderen wilt verwijderen?";
                let r = confirm(message);
                if (r) {
                    this.form.deleted = true;
                    this.$emit('saveCurrentNode', this.form);
                }
            },

            articleSuggestions: function() {
                let suggestions = [];

                _.forEach(this.domains, (domain) => {
                    if (domain.domain_translation_set.length <= 0) {
                        return;
                    }
                    _.forEach(domain.subdomain_set, (subdomain) => {
                        if (subdomain.subdomain_translation_set.length <= 0) {
                            return;
                        }

                        _.forEach(subdomain.article_set, (article) => {
                            if (article.article_translation_set.length <= 0) {
                                return;
                            }
                            suggestions.push({
                                'article_id': article.id,
                                'domain': domain.domain_translation_set[0].name,
                                'subdomain': subdomain.subdomain_translation_set[0].name,
                                'article_title': article.article_translation_set[0].title,
                                'article_details': article
                            })
                        })
                    });
                });
                return suggestions;
            },

            onArticleSelected: function(obj) {
                this.form.article = obj.article_id;
                this.form.article_details = obj.article_details
            },

            getButtonClass: function() {
                let className = 'btn btn-primary';
                if (this.product) {
                    className += ' background-' + this.product;
                }
                return className;
            }
        }
    }
</script>
<style scoped="">
    .modal-backdrop{
        position: fixed;
        width: 100%;
        height: 100%;
        top:0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 1040;
        display:block;
        background-color: rgba(0, 0, 0, 0.3);
    }

    .modal-dialog {

    }
</style>


// WEBPACK FOOTER //
// resources/js/components/decision-tree/NodeForm.vue